export const defaultState = {
  isFetching: false,
  hasFailed: false,
  errorMsg: "",
  data: [],
  metadata: {},
  history: [],
  healthCategories: [],
  supplements: [],
};
